import { createRouter, createWebHashHistory } from 'vue-router'
import WorkbenchLayout from '../layout/WorkbenchLayout.vue'
import SettingLayout from '../layout/SettingLayout.vue'
import useUserStore from '../store/user'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/chatLogin',
      component: () => import('../views/login/login.vue'),
    },
    {
      path: '/login',
      component: () => import('../views/login/login.vue'),
    },
    {
      path: '/',
      component: () => import('../views/index/Index.vue'),
      children: [
        {
          path: '',
          component: () => import('../views/index/Product.vue'),
        },
        {
          path: 'enterprise',
          component: () => import('../views/index/Enterprise.vue'),
        },
        // {
        //   path: 'resource',
        //   component: () => import('../views/index/Resource.vue'),
        // },
        {
          path: 'price',
          component: () => import('../views/index/Price.vue'),
        },
      ],
    },
    {
      path: '/workbench',
      component: WorkbenchLayout,
      redirect: '/workbench/index',
      children: [
        {
          path: 'index',
          component: () => import('../views/work-bench/work-bench.vue'),
        },
        // {
        //   path: 'personal',
        //   name: 'personal',
        //   component: () => import('../views/work-bench/work-bench-personal.vue'),
        // },
        {
          path: 'recent',
          component: () => import('../views/work-bench/recently-used.vue'),
        },
        {
          path: 'star',
          component: () => import('../views/work-bench/my-favorite.vue'),
        },
        {
          path: 'setting',
          component: () => import('../views/work-bench/work-bench.vue'),
        },
        {
          path: '/settings/settings',
          component: () => import('../views/user-setting/user-setting.vue'),
          meta: {
            title: '个人设置',
          },
        },
        {
          path: 'resource-list',
          component: () => import('../views/resource/setting-resource.vue'),
        },
        {
          path: 'download-list',
          component: () => import('../views/download-list/download-list.vue'),
        },
      ],
    },
    {
      path: '/settings',
      component: SettingLayout,
      redirect: '/settings/member',
      children: [
        {
          path: 'member',
          component: () => import('../views/member-manage/member-manage.vue'),
        },
        {
          path: 'space',
          component: () => import('../views/space-manage/space-manage.vue'),
        },
        {
          path: 'project',
          component: () => import('../views/project-manage/project-manage.vue'),
        },
        {
          path: 'enterprise',
          component: () => import('../views/enterprise-setting/enterprise-setting.vue'),
        },
        {
          path: 'parts',
          component: () => import('../views/parts/Parts.vue'),
        },
        {
          path: 'resource',
          component: () => import('../views/resource/setting-resource.vue'),
        },
      ],
    },
    {
      path: '/invite',
      name: 'invite',
      component: () => import('../views/invite/invite-employee-index.vue'),
    },
  ],
})

const whiteList = ['/', '/enterprise', '/price', '/login', '/chatLogin', '/workbench/index']

router.beforeEach((to, _from, next) => {
  const userStore = useUserStore()

  if (
    !userStore.isLogin &&
    to.path === '/login' &&
    !to.query.redirect &&
    to.query.from !== 'setup'
  ) {
    next('/')
    return
  }

  if (!userStore.isLogin && !whiteList.includes(to.path)) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }

  next()
})

export default router
